<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>设备详情</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="content-wrapper">
         <div class="detail-title">设备状态</div>
         <DeviceStatus :uid="deviceUid"></DeviceStatus>
      </div>

      <div class="detail-record" v-if="settingInfo.masterDeviceSwitch">
         <span>最近一次人脸库导出记录：
            {{ faceExportInfo.exportTime ? $util.dateFormat(faceExportInfo.exportTime, 'yyyy-MM-dd HH:mm:ss') : '' }}
         </span>
         <span class="record-success" v-if="faceExportInfo.status == 1">导出成功</span>
         <span class="record-failure" v-if="faceExportInfo.status == 0">导出失败</span>
      </div>

      <div class="content-wrapper">
         <div class="detail-title title-margin">智慧体育盒子</div>
         <el-table :data="upgradeList" border style="width: 100%;">
            <el-table-column align="center" label="当前版本" prop="versionCode"> </el-table-column>
            <el-table-column align="center" label="更新日期" prop="updateTime"></el-table-column>
            <el-table-column align="center" label="最近配置的更新" prop="lastVersionCode"></el-table-column>
            <el-table-column align="center" label="操作" width="100">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="clickUpdate(row)">更新</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="content-wrapper">
         <div class="detail-title title-margin">外接设备</div>
         <el-table :data="externalList" border style="width: 100%;">
            <el-table-column align="center" label="序号" width="80" type="index"></el-table-column>
            <el-table-column align="center" label="类型" prop="deviceType"></el-table-column>
            <el-table-column align="center" label="名称" prop="deviceName"></el-table-column>
            <el-table-column align="center" label="IP地址" prop="ipAddress"></el-table-column>
            <el-table-column align="center" label="设备密码" prop="devicePassword"></el-table-column>
            <el-table-column align="center" label="当前版本" prop="versionCode"> </el-table-column>
            <el-table-column align="center" label="主控机器" v-if="settingInfo.masterDeviceSwitch">
               <template scope="{ row }">
                  <span>{{ handleMainControlState(row) }}</span>
                  <el-button class="margin-left-10" type="text" @click="clickEditMainControl(row)">编辑</el-button>
               </template>
            </el-table-column>
            <el-table-column align="center" label="更新日期" prop="updateTime"></el-table-column>
            <el-table-column align="center" label="外接IPC">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="clickExternalIPC(row)">
                     {{ row.ipcNumber || 0 }}台
                  </el-button>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="160">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="handleExternalUpdate(row)">更新</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <el-dialog title="设备更新" destroy-on-close v-model="updateDialog.visible" :close-on-click-modal="false"
         :modal-append-to-body="false">
         <el-form label-width="100px">
            <el-form-item label="选择固件版本:">
               <el-select v-model="updateDialog.selectId" placeholder="请选择固件版本" filterable style="width: 100%;">
                  <el-option v-for="(item, index) in updateDialog.data" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="版本描述内容:">
               <div>{{ updateDialog.content[updateDialog.selectId] }}</div>
            </el-form-item>
         </el-form>
         <template #footer>
            <el-button @click="updateDialog.visible = false">取消</el-button>
            <el-button type="primary" @click="clickUpdateDone">确认</el-button>
         </template>
      </el-dialog>

      <el-dialog v-model="mainControlDialog.visible" title="是否设置当前机器为主控" size="tiny" :close-on-click-modal="false"
         :modal-append-to-body="false" destroy-on-close center>
         <div class="flex-row-center">
            <el-radio-group v-model="mainControlDialog.isMainControl">
               <el-radio :label="true">是</el-radio>
               <el-radio :label="false">否</el-radio>
            </el-radio-group>
         </div>
         <div class="flex-row-center margin-top-20">修改并保存成功，会同步到一体机</div>
         <template #footer>
            <div class="flex-row-center">
               <el-button @click="mainControlDialog.visible = false">取消</el-button>
               <el-button type="primary" @click="clickEditMainControlDone">保存</el-button>
            </div>
         </template>
      </el-dialog>

   </div>
</template>

<script>
import DeviceStatus from '../Components/DeviceStatus.vue';

export default {
   components: {
      DeviceStatus
   },

   data() {
      return {
         loading: false,
         schoolId: '',
         deviceUid: '',
         faceExportInfo: {},
         settingInfo: {},
         upgradeList: [],
         externalList: [],
         updateDialog: {
            visible: false,
            deviceType: '',
            deviceName: '',
            data: [],
            content: {},
            selectId: 0,
         },
         mainControlDialog: {
            visible: false,
            externalItem: {},
            isMainControl: true,
         }
      }
   },

   mounted() {
      this.schoolId = this.$util.getUrlParam("schoolId");
      this.deviceUid = this.$util.getUrlParam("uid");
      const faceExportTime = this.$util.getUrlParam("faceExportTime");
      if (!faceExportTime) {
         this.faceExportInfo = { exportTime: '', status: '-1' };
      } else {
         const info = JSON.parse(decodeURIComponent(faceExportTime));
         const currentTime = new Date().getTime() + '';
         const exportTime = info.exportTime + '';
         if (currentTime.length === exportTime.length) {
            info.exportTime = this.$util.dateFormat(new Date(info.exportTime), 'yyyy-MM-dd hh:mm:ss');
         } else {
            info.exportTime = this.$util.dateFormat(new Date(info.exportTime * 1000), 'yyyy-MM-dd hh:mm:ss');
         }
         this.faceExportInfo = info;
      }
      this.querySettingInfo();
      this.queryUpgradeList();
      this.queryExternalList();
   },

   methods: {
      // 查询设备版本列表
      queryUpgradeList() {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v290/appUpgrade/list',
            params: { uid: this.deviceUid },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.upgradeList = []
               return
            }
            this.upgradeList = result.body.data
         }).catch(() => {
            this.upgradeList = []
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询外接设备列表
      queryExternalList() {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v290/externalDevice/list',
            params: { uid: this.deviceUid },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.externalList = [1]
               return
            }
            this.externalList = result.body.data
         }).catch(() => {
            this.externalList = []
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询固件包版本列表
      queryFirmwareList(queryType, deviceType, deviceName) {
         this.loading = true;
         let params = {
            uid: this.deviceUid,
            deviceType: queryType,
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/list',
            params: params,
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.updateDialog.deviceType = ''
               this.updateDialog.deviceName = ''
               this.updateDialog.data = []
               this.updateDialog.selectId = 0
               this.$util.errorMsg('暂未查询到固件版本')
               return
            }
            this.updateDialog.data = result.body.data.map((item) => {
               this.updateDialog.content[item.id] = item.content
               return {
                  label: item.versionCode,
                  value: item.id,
               }
            })
            this.updateDialog.selectId = this.updateDialog.data[0].value
            this.updateDialog.visible = true
            this.updateDialog.deviceType = deviceType
            this.updateDialog.deviceName = deviceName
         }).catch(() => {
            this.updateDialog.deviceType = ''
            this.updateDialog.deviceName = ''
            this.updateDialog.data = []
            this.updateDialog.selectId = 0
            this.$util.errorMsg('查询固件版本失败')
         }).finally(() => {
            this.loading = false;
         })
      },

      // 发送更新固件包版本
      sendUpdateFirmware() {
         this.loading = true;
         let param = {
            uid: this.deviceUid,
            deviceType: this.updateDialog.deviceType,
            deviceName: this.updateDialog.deviceName,
            appUpgradeId: this.updateDialog.selectId
         }
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/update',
            body: param,
         }).then((result) => {
            if (result.body.data === true) {
               this.updateDialog.visible = false;
               this.$util.successMsg('更新成功');
               this.queryUpgradeList();
               this.queryExternalList();
            } else {
               this.$util.errorMsg(result.body.msg);
            }
         }).catch(() => {
            this.updateDialog.visible = false;
            this.$util.errorMsg('更新失败');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询学校设置信息
      querySettingInfo() {
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/basic/school/v260/info',
            params: { schoolId: this.schoolId },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            if (res.data && JSON.stringify(res.data) !== '{}') {
               this.settingInfo = { ...res.data.data };
            } else {
               this.settingInfo = {};
            }
         }).catch(() => {
            this.settingInfo = {};
         });
      },

      // 更新主控设备
      updateMainControl() {
         this.$http({
            method: "post",
            url: this.$util.aioIP + '/api/m/hw/master/v430/update',
            body: JSON.stringify({ sn: this.mainControlDialog.externalItem.sn, uid: this.deviceUid }),
         }).then((response) => {
            if (response.data.data) {
               this.$util.successMsg('设置成功');
               this.queryExternalList();
               this.mainControlDialog.visible = false;
            } else {
               this.$util.errorMsg(response.data.msg || '设置失败');
            }
         }).catch(() => {
            this.$util.errorMsg('设置失败');
         });
      },

      // 删除主控设备
      deleteMainControl() {
         this.$http({
            method: "post",
            url: this.$util.aioIP + '/api/m/hw/master/v430/delete',
            body: JSON.stringify({ sn: this.mainControlDialog.externalItem.sn }),
         }).then((response) => {
            if (response.data.data) {
               this.$util.successMsg('删除成功');
               this.queryExternalList();
               this.mainControlDialog.visible = false;
            } else {
               this.$util.errorMsg(response.data.msg || '删除失败');
            }
         }).catch(() => {
            this.$util.errorMsg('删除失败');
         });
      },

      // 点击智慧体育盒子设备更新
      clickUpdate(row) {
         if (row.deviceType === '体育盒子软件') {
            this.queryFirmwareList('高校体育盒子软件', '高校体育盒子软件', '高校体育盒子软件');
         } else {
            this.queryFirmwareList(row.deviceType, row.deviceType, row.deviceType);
         }
      },

      // 点击外接设备
      clickExternalIPC(row) {
         this.$router.push({
            path: '/xiaoyuan/equipment/list/detail/brain',
            query: {
               uid: this.deviceUid,
               type: 'box'
            }
         })
      },

      // 点击外接设备更新
      handleExternalUpdate(row) {
         if (row.deviceType === '超脑' || row.deviceType === '算力盒子') {
            this.queryFirmwareList(row.deviceType, row.deviceType, row.deviceName || '')
         } else {
            this.queryFirmwareList('IPC', row.deviceType, row.deviceName || '')
         }
      },

      // 点击更新弹框确定
      clickUpdateDone() {
         this.sendUpdateFirmware();
      },

      // 点击编辑主控设备
      clickEditMainControl(row) {
         this.mainControlDialog.externalItem = row;
         this.mainControlDialog.visible = true;
      },

      // 点击编辑主控设备弹框确定
      clickEditMainControlDone() {
         if (this.mainControlDialog.isMainControl) {
            this.updateMainControl();
         } else {
            this.deleteMainControl();
         }
      },

      // 处理主控状态
      handleMainControlState(row) {
         if (!row.masterDeviceUid) {
            return '未设置'
         } else if (row.uid === row.masterDeviceUid) {
            return '当前机器'
         } else {
            return '非当前机器'
         }
      }
   }
}
</script>

<style scoped>
.detail-title {
   font-size: 16px;
   font-weight: 500;
   color: #333333;
}

.title-margin {
   margin: 40px 0px 20px 0px;
}

.detail-record {
   padding: 20px;
   background-color: #FFFFFF;
   border-radius: 16px;
}

.record-success {
   margin-left: 20px;
   color: #15CD85;
}

.record-failure {
   margin-left: 20px;
   color: var(--xty-red-color);
}
</style>


// WEBPACK FOOTER //
// EquipmentBoxDetail.vue?0a07e0e7